// extracted by mini-css-extract-plugin
module.exports = {"sortSimple":"Classify_sortSimple__2VIbF"};